import { apiWrapper } from "@/services/api";

export const getQrInfoForQrTicketGate = async (id, timeout = null) => {
  try {
    const response = await apiWrapper(
      "GET",
      `passes/${id}/qrcode_ticket`,
      null,
      false,
      null,
      null,
      timeout
    );
    return response.data;
  } catch (err) {
    console.log("ERROR!!! getQrInfoForQrTicketGate");
    throw err;
  }
};
